// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + "caa82812" + ".css";
};